export default function ComicReviews() {
  const reviews = [
    {
      id: 'r1',
      content: '从第一话追到现在，每一话都让人感动。洞洞杂货铺不仅仅是一部漫画，更是一个能治愈人心的温暖故事。',
      author: '漫友小枫',
      verified: true,
    },
    {
      id: 'r2',
      content: '画风太棒了！超清画质加上下拉式阅读体验，每一页都像是艺术品。强烈推荐给每一位喜欢治愈系漫画的朋友！',
      author: '星辰大海',
      verified: true,
    },
    {
      id: 'r3',
      content: '剧情安排非常巧妙，每个小故事都独立又相互关联。作者对细节的把控让人叹服，值得反复阅读。',
      author: '漫画鉴赏家',
      verified: true,
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="lg:w-3/5">
            <span className="text-xs font-medium text-foreground-500 tracking-widest">
              · 读者评价
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-3">
              漫友口碑
            </h2>

            <div className="mt-8 space-y-6">
              {reviews.map((review) => (
                <div key={review.id}>
                  <p className="font-heading text-lg md:text-xl italic text-foreground-700 leading-relaxed">
                    &ldquo;{review.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-2 mt-3">
                    <span className="text-sm font-semibold text-foreground-900">
                      {review.author}
                    </span>
                    {review.verified && (
                      <span className="inline-flex items-center gap-1 text-xs text-accent-600">
                        <i className="ri-verified-badge-fill" /> 已验证读者
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-2/5 flex justify-center">
            <div className="w-64 h-80 md:w-72 md:h-96 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20black%20and%20white%20stylized%20portrait%20of%20a%20manga%20artist%20character%2C%20side%20profile%2C%20looking%20upward%2C%20shoulder-up%20composition%2C%20clean%20white%20background%2C%20soft%20contrast%2C%20professional%20editorial%20portrait%20style%2C%20minimalist%2C%20elegant&width=600&height=800&seq=review-portrait-01&orientation=portrait"
                alt="漫画家侧影"
                title="178漫画网漫画家"
                className="w-full h-full object-cover object-top grayscale"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}